<div class="row h-100  ques-row" [attr.dir]="isRTL() ? 'rtl' : 'ltr'">
    <div class="col-12 question row p-0 g-0">
        <div class="col-md-6 record-ques col-12 order-md-1 order-2">
            <div class="h-100">
                <!-- LIVE PREVIEW (main recording) -->
                <video #previewVideo muted autoplay [hidden]="showRecordedVideo || commentRecordVisibilty"></video>

                <!-- RECORDED VIDEO -->
                <video #recordedVideo muted [hidden]="!showRecordedVideo || commentRecordVisibilty" (ended)="freezeLastFrame()"></video>

                <!-- COMMENT LIVE PREVIEW — shown only when recording a comment -->
                <video #commentPreviewVideo muted autoplay [hidden]="!commentRecordVisibilty"></video>
            </div>

            <!-- Warning if question status is COMPLETED -->
            <div *ngIf="question.recordedVideos?.status === 'COMPLETED'"
                class="alert alert-success text-center py-2 mb-2" style="font-size: 0.85rem;">
                <i class="bi bi-check-circle-fill"></i>
                <strong>{{ "interviewUi.questionCompleted" | translate }}</strong> - {{ "interviewUi.questionFinalized" | translate }}
            </div>

            <!-- Info if question answered and can add comment -->
            <div *ngIf="isQuestionCompleted && canUseComment && question.recordedVideos?.status !== 'COMPLETED'"
                class="alert alert-info text-center py-2 mb-2" style="font-size: 0.85rem;">
                <i class="bi bi-info-circle"></i>
                {{ "interviewUi.answeredCanComment" | translate }}
            </div>

            <!-- Info if answered and comment already used -->
            <div *ngIf="isQuestionCompleted && !canUseComment && question.recordedVideos?.usedAdditional && question.recordedVideos?.status !== 'COMPLETED'"
                class="alert alert-secondary text-center py-2 mb-2" style="font-size: 0.85rem;">
                <i class="bi bi-check-circle"></i>
                {{ "interviewUi.answeredWithComment" | translate }}
            </div>

            <!-- Info if no comments remaining -->
            <div *ngIf="isQuestionCompleted && !canUseComment && commentsRemaining === 0 && question.recordedVideos?.status !== 'COMPLETED'"
                class="alert alert-secondary text-center py-2 mb-2" style="font-size: 0.85rem;">
                <i class="bi bi-info-circle"></i>
                {{ "interviewUi.answeredNoComments" | translate }}
            </div>

            <!-- Camera/Mic buttons (mobile) -->
            <div class="btn-media-mobile d-flex d-md-none">
                <button class="media" (click)="toggleCamera()"
                    [disabled]="(isRecording$ | async) || (question.recordedVideos?.status === 'COMPLETED')">
                    <i class="bi media-icons"
                        [ngClass]="isVideoOn ? 'bi-camera-video-fill' : 'bi-camera-video-off'"></i>
                </button>

                <button class="media" (click)="toggleMic()"
                    [disabled]="(isRecording$ | async) || (question.recordedVideos?.status === 'COMPLETED')">
                    <i class="bi media-icons" [ngClass]="isMicOn ? 'bi-mic' : 'bi-mic-mute'"></i>
                </button>
            </div>
        </div>

        <div class="col-md-6 col-12 image-video  order-md-2 order-1">
            <div class="finish d-block d-md-none">
                <a href="#">{{ "interviewUi.finish" | translate }}</a>
            </div>

            <div>
                <img src="../../../../../assets/img/floating-robot.png" alt="robot">
                <p>{{ "interviewUi.aiTrainee" | translate }}</p>
                <p class="ques ms-2 mb-2 mb-md-0">{{ activeQuestion }}</p>

                <!-- Hidden audio element for question -->
                <audio #questionAudio style="display: none;"></audio>

                <!-- Hidden audio element for explanation -->
                <audio #explainAudio style="display: none;"></audio>

                <div class="d-flex flex-column justify-content-start">
                    <button class="border-button col-md-4 col-6 mx-auto" (click)="getQuestionExplanation()"
                        *ngIf="hasExplanation" [disabled]="isLoadingExplanation">
                        {{ isLoadingExplanation ? ("Loading..." | translate) : ("interviewUi.explain" | translate) }}
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="col-12 controls">
        <div class="row justify-center align-items-center">
            <!-- Desktop camera/mic buttons -->
            <div class="btn-media d-none d-md-flex col-2">
                <button class="media" (click)="toggleCamera()" [disabled]="(isRecording$ | async)">
                    <i class="bi media-icons"
                        [ngClass]="isVideoOn ? 'bi-camera-video-fill' : 'bi-camera-video-off'"></i>
                </button>

                <button class="media" (click)="toggleMic()" [disabled]="(isRecording$ | async)">
                    <i class="bi media-icons" [ngClass]="isMicOn ? 'bi-mic' : 'bi-mic-mute'"></i>
                </button>
            </div>

            <!-- Recording Controls & Visualizer -->
            <div class="col-10 h-100 col-md-8 p-0">
                <!-- Info message if question already answered -->
                <div *ngIf="isQuestionCompleted && question.recordedVideos?.status == 'COMPLETED'"
                    class="alert alert-info text-center py-2 mb-2" style="font-size: 0.85rem;">
                    <i class="bi bi-info-circle"></i>
                    {{ "interviewUi.answeredAlready" | translate }}
                </div>

                <div class="col-12 col-md-9 mx-md-auto mx-0 recording-control d-flex align-items-center g-0 h-100">
                    <!-- Record/Stop Button -->
                    <div class="btns col-3 col-md">
                        <button *ngIf="!(isRecording$ | async); else stopBtn" class="record-icon" (click)="start()"
                            [disabled]="isTimeUp || !isVideoOn || !isMicOn || !canRecord || isQuestionCompleted || question.recordedVideos?.status === 'COMPLETED'"
                            [style.opacity]="(isTimeUp || !isVideoOn || !isMicOn || !canRecord || isQuestionCompleted || question.recordedVideos?.status === 'COMPLETED') ? '0.5' : '1'"
                            [title]="question.recordedVideos?.status === 'COMPLETED'
                                ? ('interviewUi.completedSubmitted' | translate)
                                : isQuestionCompleted
                                    ? ('interviewUi.answeredAlready' | translate)
                                    : isTimeUp
                                        ? ('interviewUi.timeLimitReached' | translate)
                                        : (!isVideoOn || !isMicOn)
                                            ? ('interviewUi.turnOnCameraMic' | translate)
                                            : !canRecord
                                                ? ('interviewUi.cannotRecordAgain' | translate)
                                                : ('interviewUi.startRecording' | translate)">
                            <i class="bi bi-play-circle"></i>
                        </button>

                        <ng-template #stopBtn>
                            <button class="record-icon" (click)="stop()">
                                <i class="bi bi-stop-circle stop"></i>
                            </button>
                        </ng-template>
                    </div>

                    <!-- Audio Visualizer -->
                    <div class="audio-visualizer-container col-5 col-md">
                        <div class="waveform">
                            <span *ngFor="let bar of bars" [style.height.px]="bar"></span>
                        </div>
                    </div>

                    <!-- Timer -->
                    <div class="time col-4 col-md">
                        {{ formatDuration(currentTime) }}/{{ formatDuration(maxTime) }}
                    </div>
                </div>
            </div>

            <!-- Next/Submit Button -->
            <div class="col-2 d-flex buttons h-100">
                <button class="gradient-button my-auto" (click)="onNext()" *ngIf="!onSubmit()"
                    [disabled]="(isRecording$ | async) || !startFlag">
                    <span class="d-none d-md-block">{{ "interviewUi.next" | translate }} ></span>
                            <span class="d-block d-md-none">{{ isRTL() ? '>' : '>' }}</span>
                </button>

                <button class="submit my-auto" [disabled]="(isRecording$ | async) || !startFlag" (click)="onNext()"
                    *ngIf="onSubmit()">
                    <span class="d-none d-md-block">{{ "interviewUi.send" | translate }} ></span>
                            <span class="d-block d-md-none">{{ isRTL() ? '>' : '>' }}</span>
                </button>
            </div>
        </div>
    </div>

    <!-- ═══ Comment Section — only shown when remainingAdditionalAttempts is defined and > 0 ═══ -->
    <div class="col-12 comment-section-wrapper" *ngIf="question?.remainingAdditionalAttempts !== undefined && (commentsRemaining > 0 || commentRecordVisibilty)">

        <div class="comment-info col-12 mt-5" *ngIf="!commentRecordVisibilty">
            <!-- Warning message if camera/mic not enabled for comment -->
            <div *ngIf="(!isVideoOn || !isMicOn) && commentsRemaining > 0" class="alert alert-warning text-center py-1"
                style="font-size: 0.85rem;">
                <i class="bi bi-exclamation-triangle"></i>
                {{ "interviewUi.enableCameraMicComment" | translate }}
            </div>

            <div class="comment-tries" *ngIf="commentsRemaining > 0">
                <ul>
                    <li>
                        <h6>{{ "interviewUi.commentsRemaining" | translate:{ count: commentsRemaining } }}</h6>
                        <p>{{ "interviewUi.commentsHintDuration" | translate:{ duration: getCommentMaxDurationSec() } }}</p>
                    </li>
                </ul>
                <button [disabled]="commentsRemaining === 0 || currentQuestionComments.length > 0"
                    (click)="ToggleCommentRecoder()">
                    {{ "interviewUi.useNow" | translate }}
                </button>
            </div>
        </div>

        <div class="comment-recoder" *ngIf="commentRecordVisibilty">
            <p>
                <span>{{ getCommentLabel() }}</span>
            </p>

            <div class="row">
                <div class="col-12 comment-conroller d-flex align-items-center">
                    <!-- Record/Stop Button -->
                    <div>
                        <button *ngIf="!isCommentRecording; else stopCommentBtn"
                            [disabled]="!canUseComment || commentsRemaining === 0 || (isRecording$ | async) || currentQuestionComments.length > 0 || !isVideoOn || !isMicOn"
                            (click)="startCommentRecording()" class="record-icon"
                            [class.disabled]="currentQuestionComments.length > 0">
                            <i class="bi bi-play-circle"></i>
                        </button>

                        <ng-template #stopCommentBtn>
                            <button class="record-icon" (click)="stopCommentRecording()">
                                <i class="bi bi-stop-circle stop"></i>
                            </button>
                        </ng-template>
                    </div>

                    <!-- Audio Visualizer for Comments -->
                    <div>
                        <div class="waveform comment-waveform">
                            <span *ngFor="let commentbar of commentBars" [style.height.px]="commentbar"
                                [class.active]="isCommentRecording"></span>
                        </div>
                    </div>

                    <!-- Timer -->
                    <div class="time">
                        <span *ngIf="isCommentRecording">
                            {{ formatCommentTime(commentElapsedTime) }} / {{ formatCommentTime(getCommentMaxDurationSec()) }}
                        </span>
                        <span *ngIf="!isCommentRecording && commentFinalTime > 0">
                            {{ formatCommentTime(commentFinalTime) }} / {{ formatCommentTime(getCommentMaxDurationSec()) }}
                        </span>
                        <span *ngIf="!isCommentRecording && commentFinalTime === 0">
                            00:00 / {{ formatCommentTime(getCommentMaxDurationSec()) }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
